module.exports = __webpack_public_path__ + "static/assets/99745f08bcfc95aa9e1f9e9f34f4bf3e.svg";